'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/clock/circle.tsx
import { jsx } from "react/jsx-runtime";
var ClockIcon = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.9957 21.732C16.9285 21.732 21 17.6605 21 12.7364C21 7.81225 16.9198 3.74072 11.9869 3.74072C7.06283 3.74072 3 7.81225 3 12.7364C3 17.6605 7.07153 21.732 11.9957 21.732ZM11.9957 19.9399C8.00242 19.9399 4.80957 16.7296 4.80957 12.7364C4.80957 8.74314 8.00242 5.54159 11.9869 5.54159C15.9802 5.54159 19.1904 8.74314 19.1991 12.7364C19.2078 16.7296 15.9889 19.9399 11.9957 19.9399ZM7.61092 13.8326H11.9869C12.3871 13.8326 12.6916 13.5281 12.6916 13.1366V7.44686C12.6916 7.05537 12.3871 6.75087 11.9869 6.75087C11.6042 6.75087 11.2997 7.05537 11.2997 7.44686V12.4406H7.61092C7.21943 12.4406 6.91493 12.7451 6.91493 13.1366C6.91493 13.5281 7.21943 13.8326 7.61092 13.8326Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/clock/SemiCircleClock.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var SemiCircleClockIcon = (props) => /* @__PURE__ */ jsx2(
  "svg",
  __spreadProps(__spreadValues({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx2(
      "path",
      {
        d: "M11.9957 21C16.9459 21 21 16.9459 21 11.9957C21 7.05413 16.9546 3 12.0043 3C11.465 3 11.1605 3.32189 11.1605 3.84389V7.04543C11.1605 7.48913 11.4737 7.83712 11.9174 7.83712C12.361 7.83712 12.6742 7.48913 12.6742 7.04543V4.80957C16.3543 5.14886 19.1904 8.22861 19.1904 11.9957C19.1904 15.9802 15.9976 19.1991 11.9957 19.1991C8.00242 19.1991 4.79217 15.9802 4.80087 11.9957C4.80957 10.2818 5.40986 8.68971 6.41904 7.46303C6.74964 7.01063 6.80184 6.53214 6.42774 6.15805C6.05365 5.78395 5.45336 5.81875 5.06187 6.33204C3.78299 7.88062 3 9.85549 3 11.9957C3 16.9459 7.05413 21 11.9957 21ZM13.3963 13.3354C14.1097 12.5785 13.9618 11.552 13.1092 10.9691L8.68971 7.93282C8.16771 7.58482 7.66312 8.09811 8.01112 8.62011L11.0474 13.0309C11.6303 13.8922 12.6568 14.0488 13.3963 13.3354Z",
        fill: "currentColor"
      }
    )
  })
);

export {
  ClockIcon,
  SemiCircleClockIcon
};
//# sourceMappingURL=chunk-M4IOOFZX.mjs.map